import { PropsWithChildren } from 'react';
import { TableTabs } from './index';
import { PortalTo } from '$/components/Portal';

interface WrapperProps {
  tabs?: string[];
}
export const TabsWrapper = (props: PropsWithChildren<WrapperProps>) => {
  return (
    <>
      <PortalTo rootId="comparison-table-tabs">
        <TableTabs tabs={props.tabs} />
      </PortalTo>
      {props.children}
    </>
  );
};
